<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Phrase Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Phrases</li>
        <li class="active">Phrase List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Phrase List</h3>
              <div class="action-button pull-right">  
                <router-link class="btn btn-primary" :to="`PhrasesDetails`">Add Phrase</router-link>
              </div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>

            <div class="box-footer no-border">
              <div class="row">
                <div class="col-md-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="phraseData"
                    :totalRows="phraseCount"
                     :pagination-options="{
                        enabled: true,
                        perPage: 20
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-quote-left" title="No phrases found" hint="Try changing the filters, or add a new phrase." action-label="Add phrase" action-to="/PhrasesDetails" /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />

                        <span v-if="props.column.field == 'createdAt'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'edit'">
                          <router-link :to="`PhrasesDetails?phraseId=${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field == 'delete'">
                          <i class="fa fa-times-circle" aria-hidden="true" v-on:click="showDeleteConfirmationPopup(props.row, props.index)"></i>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
      <deleteConfirmationModal
        v-if="isDeleteConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deletePhrase="deletePhrase"
        :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />

    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import moment from 'moment'
import flatPickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import api from '../../../utils/api'
import deleteConfirmationModal from './../popup/deleteConfirmation'
import { formatDate, getSelectorValue } from '../../../utils/utilities'

export default {
  name: 'phraseDashboard',
  components: {
    'deleteConfirmationModal': deleteConfirmationModal,
    flatPickr
  },
  mounted () {
    this.getAllPhrasesFromDB()
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true
    })
  },
  data () {
    return {
      formatDate: formatDate,
      loading: true,
      actionInProgress: false,
      isModalVisible: false,
      isDeleteConfirmationVisible: false,
      validationErrors: [],
      phraseData: [],
      phraseCount: 0,
      clonedPhraseData: [],
      actionToBePerformed: 'Add Phrase',
      confirmationMessage: 'Are you sure you want to delete this phrase?',
      rowIndexToBeUpdated: 0,
      defaultRowObj: {
        id: null,
        phrase: '',
        keyword: '',
        locationid: '',
        createdAt: ''
      },
      gRowObj: {
        id: null,
        phrase: '',
        keyword: '',
        locationid: '',
        createdAt: ''
      },
      tableQueryParams: {
        columnFilters: {is_deleted: false},
        sort: {
          createdAt: -1
        },
        page: 1,
        perPage: 20
      },
      columns: [
        {
          label: 'Phrase',
          field: 'phrase',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Phrase'
          }
        },
        {
          label: 'Keyword',
          field: 'keyword',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Keyword'
          }
        },
        {
          label: 'Country',
          field: 'country',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Country'
          }
        },
        {
          label: 'Created On',
          field: 'createdAt',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Edit',
          field: 'edit',
          sortable: false
        },
        {
          label: 'Delete',
          field: 'delete',
          sortable: false
        }
      ],
      previousQueryParams: {}
    }
  },
  methods: {
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getAllPhrasesFromDB()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getAllPhrasesFromDB()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType === 'asc' ? 1 : -1
        }
      })
      this.getAllPhrasesFromDB()
    },
    onColumnFilter (params) {
      let appliedFilter = {isdeleted: false}
      for (const key in params.columnFilters) {
        if (key === 'createdAt') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['createdFromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['createdToDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.getAllPhrasesFromDB()
    },
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Phrase'
      }, 500)
    },
    closeModal () {
      console.log('inside closeModal function')
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isDeleteConfirmationVisible = false
      this.validationErrors = []
      this.gRowObj = Object.assign({}, this.resetGRowObj())
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Phrase'
      }, 500)
    },
    showDeleteConfirmationPopup (phraseData, index) {
      console.log('inside showDeleteConfirmationPopup')
      this.actionToBePerformed = 'Delete Phrase'
      this.confirmationMessage = 'Are you sure you want to delete this phrase?'
      this.isDeleteConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },
    getAllPhrasesFromDB (fromDeleteKeyword = false) {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      if (JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams) && !fromDeleteKeyword) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }

      api.buildRequest('getPhraseList', 'POST', queryParams)
      .then(response => {
        this.loading = false
        if (response.status === 200) {
          this.previousQueryParams = queryParams
          if (response.data.payload.phrases.length > 0) {
            this.phraseData = response.data.payload.phrases
            this.clonedPhraseData = this.phraseData
            this.phraseCount = response.data.payload.phraseCount
          } else {
            this.phraseData = []
            this.clonedPhraseData = this.phraseData
          }
        } else {
          console.log('something went wrong')
        }
      }).catch(({ response }) => {
        this.loading = false
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    },
    deletePhrase () {
      this.loading = true
      console.log('deletePhrase')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRow = this.phraseData[this.rowIndexToBeUpdated]
      this.phraseData.splice(this.rowIndexToBeUpdated, 1)
      console.log('spliced phraseData')
      console.log(this.phraseData)
      var self = this
      api.buildRequest('deletePhrase', 'POST', { deletedRow })
      .then(response => {
        self.loading = false
        self.rowIndexToBeUpdated = 0
        self.closeModal()
        if (response.status === 200) {
          self.isDeleteConfirmationVisible = false
          this.$swal({
            type: 'success',
            text: response ? response.data.payload.message : 'Phrase deleted successfully'
          }).then(() => {
            this.getAllPhrasesFromDB(true)
          })
        } else {
          console.log('something went wrong')
        }
      }).catch(({ response }) => {
        self.closeModal()
        self.rowIndexToBeUpdated = 0
        self.isDeleteConfirmationVisible = false
        self.actionInProgress = false
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    },
    resetGRowObj () {
      console.log('inside resetGRowObj method')
      return this.defaultRowObj
    },
    trimJsonObj (obj) {
      const trimmedObj = {}
      Object.keys(obj).forEach(function (key) {
        console.log(key, obj[key])
        trimmedObj[key] = obj[key]
        if (obj[key] !== undefined && typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim()
        }
      })
      return trimmedObj
    }
  }
}
</script>
<style>
.vgt-inner-wrap.is-loading {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.good-table td {
  white-space: normal;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
</style>


// WEBPACK FOOTER //
// phrasesList.vue?fe906d20